import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { ContactoClienteSelector } from "app/features/selectores";

type Entity = models.OrigenUsuarioApi;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => void;
    onGuardar: () => void;
    nuevo: boolean;
    idCliente: number;
}

/**Vista de la forma para editar un usuarioAPI */
class OrigenUsuarioApiFormNoRx extends React.PureComponent<Props>  {
    get rules(): validation.Rules<Entity> {
        const reglas: validation.Rules<Entity> = {
            Clave: validation.required,
            IdSucursal: validation.required,
            IdContactoCliente: validation.required,
        }


        return reglas;
    }

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    render() {
        const getField = this.getField;
        const Text = getField(kea.Text);
        const ContactoCliente = getField(selectores.ContactoClienteSelector)
        const Sucursal = getField(selectores.Sucursal);

        return (
            <div>
                <kea.Title titulo="Origen usuario API" />
                {kea.autogrid(6, [
                    <Text field="Clave" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <ContactoCliente field="IdContactoCliente" label="Contacto" filtroCliente={{
                        IdRegistro: this.props.idCliente
                    }} />,
                ])}


                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={this.props.onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>
        );
    }
}

export const OrigenUsuarioApiForm = componentToRx(OrigenUsuarioApiFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/origen/edit/form.tsx